import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';

import { CajaButtons } from '../../../components/CajaButtons';
import { HirerPaymentTerms } from '../../../components/HirerPaymentTerms';
import TransactionError from '../../../components/TransactionError';
import { usePayments } from '../../../context/PaymentsProvider';
import translations from '../../../locales.vocab';
import { useMobileView } from '../../../usecases/MobileView/useMobileView';
import { getPaymentMethods } from '../../../utils/getPaymentMethods';

import PaymentDetails from './PaymentDetails';

const defaultProps = {
  features: {
    creditcard: true,
    idOnlineBanking: true,
    idEWallet: true,
    idQRIS: true,
    invoice: true,
  },
  invoiceOnly: false,
  cpqaOnly: false,
  hideAllPayments: false,
};

const SeekJobsID = () => {
  const { t } = useTranslations(translations);
  const isMobileView = useMobileView();
  const {
    paymentMethod,
    invoiceOnly = defaultProps.invoiceOnly,
    hideAllPayments = defaultProps.hideAllPayments,
    isAdBudgetSelected = false,
    postAdButtonText = t('pay.button.submit.caja'),
    previewButtonComponent,
    backButtonComponent,
    site,
    env,
    isPaymentInProgress,
    errorMessage,
    feature = defaultProps.features,
    handlePayAndPostButtonClick,
    onRadioChange,
    onlineBanking,
    currency,
    onCompleteFromThirdParty,
    cpqaOnly = defaultProps.cpqaOnly,
    useCase,
  } = usePayments();

  if (!onlineBanking) {
    return <></>;
  }

  if (invoiceOnly || cpqaOnly) {
    feature.creditcard = false;
    feature.idOnlineBanking = false;
    feature.idEWallet = false;
    feature.idQRIS = false;
  } else {
    feature.creditcard = true;
    feature.idOnlineBanking = true;
    feature.idEWallet = true;
    feature.idQRIS = true;
  }

  const availablePaymentMethods = getPaymentMethods('ID', feature);

  return (
    <>
      <Box hidden={hideAllPayments}>
        <PaymentDetails
          currency={currency}
          onRadioChange={onRadioChange}
          paymentMethod={paymentMethod}
          availablePaymentMethods={availablePaymentMethods}
          invoiceOnly={invoiceOnly}
          cpqaOnly={cpqaOnly}
          hideAllPayments={hideAllPayments}
          isAdBudgetSelected={isAdBudgetSelected}
          useCase={useCase}
          onCompleteFromThirdParty={onCompleteFromThirdParty}
          feature={feature}
        />
      </Box>

      {errorMessage && (
        <Box marginTop="medium" paddingX={['gutter', 'none']}>
          <TransactionError transactionErrorMessage={errorMessage} />
        </Box>
      )}

      <Box
        paddingTop={hideAllPayments ? 'none' : 'xlarge'}
        paddingBottom="medium"
      >
        <HirerPaymentTerms
          isAdBudgetSelected={isAdBudgetSelected}
          useCase={useCase}
          site={site}
          isStaging={env === 'staging'}
        />
      </Box>
      <CajaButtons
        isMobileView={isMobileView}
        backButtonComponent={backButtonComponent}
        previewButtonComponent={previewButtonComponent}
        isPaymentInProgress={isPaymentInProgress}
        handlePayAndPostButtonClick={handlePayAndPostButtonClick}
        postAdButtonText={postAdButtonText}
      />
    </>
  );
};

export default SeekJobsID;
